import { BehaviorSubject } from "rxjs";
import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";

export const applicantService = {
  getAllApplicant,
  getApplicant,
  addApplicantEducation,
  addApplicantExperience,
  addApplicationSkills,
  updateApplicantEducation,
  updateApplicantExperience,
  removeApplicantEducation,
  removeApplicantExperience
};

function getAllApplicant(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/getAllApplicant?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getApplicant(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/getApplicantById?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addApplicantEducation(
  applicantId,
  degree,
  institute,
  discipline,
  startYear,
  endYear
) {
  var req = {
    applicantId,
    institute,
    degree,
    discipline,
    startYear,
    endYear
  };
  return fetch(
    `${config.apiurl}/Miscellaneous/createApplicantEducation`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addApplicationSkills(req) {
  return fetch(
    `${config.apiurl}/application/postApplicationSkills`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addApplicantExperience(
  applicantId,
  companyName,
  position,
  startYear,
  endYear,
  description
) {
  var req = {
    applicantId,
    companyName,
    position,
    startYear,
    endYear,
    description
  };
  return fetch(
    `${config.apiurl}/Miscellaneous/createApplicantExperience`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateApplicantExperience(
  id,
  applicantId,
  companyName,
  position,
  startYear,
  endYear,
  description
) {
  var req = {
    applicantId,
    companyName,
    position,
    startYear,
    endYear,
    description
  };
  return fetch(
    `${config.apiurl}/miscellaneous/UpdateApplicantExperience/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateApplicantEducation(
  id,
  applicantId,
  degree,
  institute,
  discipline,
  startYear,
  endYear
) {
  var req = {
    applicantId,
    degree,
    institute,
    discipline,
    startYear,
    endYear
  };
  return fetch(
    `${config.apiurl}/miscellaneous/UpdateApplicantEducation/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeApplicantEducation(Id) {
  return fetch(
    `${config.apiurl}/miscellaneous/DeleteApplicantEducation/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function removeApplicantExperience(Id) {
  return fetch(
    `${config.apiurl}/miscellaneous/DeleteApplicantExperience/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}



// WEBPACK FOOTER //
// ./src/services/applicantService.js